// Module
var code = "<div layout=\"column\" class=\"full-height\"> <iframe id=\"sisense-jwt\" ng-src=\"{{$ctrl.iframeSrc}}\" width=\"0\" height=\"0\"></iframe> <div flex id=\"sisense-container\"></div> </div> ";
// Exports
export default code;